
import MainLayout from '../Layout/MainLayout';
import Hero from '../Components/HERO/Hero';
import ContactSec from '../Components/ContactSec';
import AboutSec from '../Components/AboutSec';
// import Sec1 from '../Components/Sec1';
import {Service} from '../Components/Services/Service'
import FlagSlider from '../Components/Slider/FlagSlider';
import LogoSlider from '../Components/Slider/LogoSlider'

import ClientReview from '../Components/ClientReview/ClientReview';
// import Counter from '../Components/Counter/Counter';
// import CountrySlider from '../Components/Slider/CountrySlider';
import Process from '../Components/Process/Process';
import MeetourTeam from '../Components/Meetteam/MeetourTeam';
import { Helmet } from 'react-helmet';



// import NEW  from '../Modal/NEW';



function Home() {




  return (
    <>
    <Helmet>
        <title>Beyond Digitizing – Premium Embroidery Digitizing Services</title>
        <meta name="description" content="Beyond Digitizing offers professional embroidery digitizing services with fast turnaround and high accuracy." />
        <meta name="keywords" content="embroidery digitizing, vector art, digitizing service, beyond digitizing" />

        {/* Open Graph for Facebook/LinkedIn */}
        <meta property="og:title" content="Beyond Digitizing – Premium Embroidery Digitizing Services" />
        <meta property="og:description" content="Beyond Digitizing offers professional embroidery digitizing services with fast turnaround and high accuracy." />
        <meta property="og:url" content="https://beyonddigitizing.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://beyonddigitizing.com/og-image.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Beyond Digitizing – Premium Embroidery Digitizing Services" />
        <meta name="twitter:description" content="Beyond Digitizing offers professional embroidery digitizing services with fast turnaround and high accuracy." />
        <meta name="twitter:image" content="https://beyonddigitizing.com/og-image.png" />
      </Helmet>
      <MainLayout>
        <Hero />
        <Service/>
        <AboutSec />
        <ClientReview/>
        <FlagSlider/>
        <MeetourTeam/> 
        <ContactSec />
        <Process/>
        {/* <Counter/> */}
        <LogoSlider/>
        
        {/* <CountrySlider/> */}
        {/* <Sec1 /> */}
      </MainLayout>
    </>
  );
}




export default Home;